import {Component} from '@angular/core';

@Component({
    selector: 'blitz-basic-script-list-box',
    templateUrl: 'list-box.html'
    //styleUrls: ['blitz-basic-script.scss']
})
export class ListBoxComponent {
    constructor() {

    }
}
